/* Home nova Suplementaria: busca, menus, painéis de objetivo, guia de 3 perguntas, carrossel, filtros.
   JavaScript puro, um ouvinte por tipo de evento, protegido contra carga dupla.
   Dados: índice do catálogo em /collections/all?view=hn-indice (campos custom.* gravados em 08/10/2026). */
(function () {
  if (window.__hnHome) return;
  window.__hnHome = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mq = window.matchMedia('(max-width:760px)');
  var hdr = $('#hn-hdr');
  var IDX_URL = hdr ? hdr.dataset.hnIndex : '/collections/all?view=hn-indice';
  var PARC = hdr ? parseInt(hdr.dataset.hnParc, 10) || 1 : 1;
  var WA = (hdr && hdr.dataset.hnWa) || '5565996827970';
  var FREE_KEY = 'hn-vistos';

  /* ---------- utilidades ---------- */
  var brl = function (v) { return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var pct = function (x) { return Math.round(x * 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
  var fold = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var toks = function (s) { return s.split(/[^a-z0-9]+/).filter(Boolean); };
  var wa = function (t) { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(t); };
  var ICO = {
    arrow: '<svg class="hn-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    back: '<svg class="hn-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>',
    info: '<svg class="hn-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v5h1"/></svg>'
  };
  function offLabel(p) {
    if (!p.c) return '';
    var d = p.c - p.p, r = d / p.c;
    if (r < 0.10) return '';
    return d >= 20 ? 'R$ ' + Math.round(d) + ' a menos' : '−' + pct(r) + '%';
  }
  function priceHTML(p, from, parc) {
    var g = p.px || p.p, s = brl(g).split(','), n = PARC > 1 && parc ? PARC : 0, card = '';
    if (p.px) card = 'R$ ' + brl(p.p) + ' no cartão' + (n ? ' ou ' + n + 'x de R$ ' + brl(p.p / n) : '');
    else if (n) card = 'ou ' + n + 'x de R$ ' + brl(p.p / n) + ' sem juros';
    return '<div class="hn-price hn-num">' + (from ? '<span class="hn-from">a partir de</span>' : '') +
      '<span class="hn-now">R$ ' + s[0] + '<sup>,' + s[1] + '</sup>' + (p.px ? '<small class="hn-pix"> no Pix</small>' : '') + '</span>' +
      (p.c ? '<span class="hn-was">R$ ' + brl(p.c) + '</span>' : '') + (card ? '<span class="hn-cardp">' + card + '</span>' : '') + '</div>';
  }
  function pic(p, w) { var src = p.cut || p.img; return src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : ''; }
  function addBtn(p, cls, label) {
    if (!p.v) return '<a class="' + cls + '" href="' + esc(p.u) + '" aria-label="Escolher opção de ' + esc(p.t) + '">' + 'Escolher' + '</a>';
    return '<form action="/cart/add" method="post" class="hn-add-form" data-cart-add-form><input type="hidden" name="id" value="' + p.v + '"><input type="hidden" name="quantity" value="1">' +
      '<button class="' + cls + '" type="submit" name="add" data-cart-add-button aria-label="Adicionar ' + esc(p.t) + ' à sacola">' + label + '</button></form>';
  }
  function card(p) {
    var off = offLabel(p);
    return '<article class="hn-card"><a class="hn-card-img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true"><span class="hn-badges">' +
      (off ? '<span class="hn-off">' + off + '</span>' : (p.mv ? '<span class="hn-badge-sold">Mais vendido</span>' : '')) + '</span>' + pic(p, 240) + '</a>' +
      '<div class="hn-card-body"><span class="hn-brand">' + esc(p.b) + '</span><h3><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
      (p.n > 1 ? '<span class="hn-meta">' + p.n + ' opções de sabor ou tamanho</span>' : '') + priceHTML(p, p.n > 1, true) +
      addBtn(p, 'hn-add', 'Adicionar à sacola') + '</div></article>';
  }
  function mrow(p) {
    return '<div class="hn-mrow"><a class="hn-pic" href="' + esc(p.u) + '" aria-label="Ver ' + esc(p.t) + '">' + pic(p, 60) + '</a>' +
      '<div class="hn-t"><b>' + esc(p.t) + '</b><small>' + esc(p.b) + (p.n > 1 ? ' · ' + p.n + ' opções' : '') + '</small>' + priceHTML(p, p.n > 1) +
      addBtn(p, 'hn-add hn-add-sm', 'Adicionar à sacola') + '</div></div>';
  }

  /* ---------- índice do catálogo (carrega sob demanda, guarda 30 min) ---------- */
  var IDX = null, idxPromise = null;
  function hydrate(all) {
    all.forEach(function (p) {
      p.ft = fold(p.t); p.tt = toks(p.ft); p.fb = fold(p.b); p.bt = toks(p.fb);
      p.fx = fold(p.x + ' ' + (p.o || []).join(' ') + ' ' + (p.i || []).join(' ') + ' ' + p.f); p.xt = toks(p.fx);
    });
    return all;
  }
  function loadIndex() {
    if (IDX) return Promise.resolve(IDX);
    if (idxPromise) return idxPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem('hn-idx2') || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000) { IDX = hydrate(c.d); return Promise.resolve(IDX); }
    } catch (e) {}
    var join = IDX_URL.indexOf('?') > -1 ? '&' : '?';
    var get = function (n) { return fetch(IDX_URL + join + 'page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); };
    idxPromise = get(1).then(function (first) {
      var reqs = [];
      for (var i = 2; i <= first.paginas; i++) reqs.push(get(i));
      return Promise.all(reqs).then(function (rest) {
        var all = first.produtos;
        rest.forEach(function (r) { all = all.concat(r.produtos); });
        all.forEach(function (p, i) { p.d = p.c ? (p.c - p.p) / p.c : 0; p.rank = i; });
        /* mais vendidos e com desconto primeiro: vira o desempate da busca */
        all.sort(function (a, b) { return (b.mv - a.mv) || (b.d - a.d) || (a.rank - b.rank); });
        all.forEach(function (p, i) { p.rank = i; });
        try { sessionStorage.setItem('hn-idx2', JSON.stringify({ t: Date.now(), d: all })); } catch (e) {}
        IDX = hydrate(all);
        return IDX;
      });
    });
    idxPromise.catch(function () { idxPromise = null; });
    return idxPromise;
  }
  var byHandle = function (h) { return IDX && IDX.find(function (p) { return p.h === h; }); };

  /* ---------- objetivos: título e link vêm dos links da página ---------- */
  var OBJ = {};
  $$('[data-hn-obj]').forEach(function (a) {
    var h = a.dataset.hnObj; if (!h || OBJ[h]) return;
    var b = a.querySelector('b'); var label = (b ? b.textContent : a.textContent).trim();
    var img = a.querySelector('img');
    OBJ[h] = { h: h, label: label, url: a.getAttribute('href'), img: img ? img.getAttribute('src') : '' };
  });
  var CUIDADO = {
    'jornada-glp-1': 'Quem usa medicamento deve conversar antes com o profissional que acompanha o tratamento.',
    'criancas-e-familia': 'Para crianças, gestantes e lactantes, a orientação de um profissional vem antes.'
  };
  var FMT = { 'Pó': 'Pó', 'Cápsula': 'Cápsula', 'Gotas ou líquido': 'Gotas ou líquido', 'Sachê': 'Sachê', 'Goma': 'Goma' };
  function objItems(o) { return IDX.filter(function (p) { return (p.o || []).indexOf(o.label) > -1; }); }
  function starters(items, fmt) {
    var list = fmt ? items.filter(function (p) { return p.f === fmt; }) : items.slice();
    if (!fmt) {
      list.sort(function (a, b) { return (b.mv - a.mv) || (b.d - a.d) || (a.p - b.p); });
      var out = [], marcas = {};
      list.forEach(function (p) { if (out.length < 3 && !marcas[p.b]) { out.push(p); marcas[p.b] = 1; } });
      list.forEach(function (p) { if (out.length < 3 && out.indexOf(p) < 0) out.push(p); });
      return out.sort(function (a, b) { return a.p - b.p; });
    }
    list.sort(function (a, b) { return a.p - b.p; });
    if (list.length <= 3) return list;
    return [list[0], list[Math.floor(list.length / 2)], list[list.length - 1]];
  }

  /* ---------- camadas: painel lateral e gaveta ---------- */
  var scrim = $('[data-hn-scrim]'), sheet = $('#hn-sheet'), drawer = $('#hn-drawer'), lastFocus = null;
  function showLayer(el) {
    if (!el) return;
    if (scrim.hidden) lastFocus = document.activeElement;
    scrim.hidden = false; el.hidden = false; document.body.classList.add('hn-lock');
    requestAnimationFrame(function () { scrim.classList.add('hn-show'); el.classList.add('hn-open'); var c = el.querySelector('[data-hn-close]'); if (c) c.focus({ preventScroll: true }); });
  }
  function closeLayers() {
    [sheet, drawer].forEach(function (el) {
      if (el && !el.hidden) { el.classList.remove('hn-open'); setTimeout(function () { if (!el.classList.contains('hn-open')) el.hidden = true; }, 360); }
    });
    if (scrim) { scrim.classList.remove('hn-show'); setTimeout(function () { if (!scrim.classList.contains('hn-show')) scrim.hidden = true; }, 260); }
    document.body.classList.remove('hn-lock');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }
  function openSheet(title, body, foot) {
    if (!sheet) return;
    if (drawer && !drawer.hidden) { drawer.classList.remove('hn-open'); drawer.hidden = true; }
    $('#hn-sheet-t').textContent = title;
    var b = $('[data-hn-sheet-body]', sheet); b.innerHTML = body; b.scrollTop = 0;
    var f = $('[data-hn-sheet-foot]', sheet); f.hidden = !foot; f.innerHTML = foot || '';
    if (sheet.hidden || !sheet.classList.contains('hn-open')) showLayer(sheet);
  }
  function loadingSheet(title) { openSheet(title, '<div class="hn-pad"><p class="hn-sb-title">Carregando…</p></div>'); }

  /* ---------- painel do objetivo ---------- */
  function openObjective(h, fmt) {
    var o = OBJ[h]; if (!o) { location.href = '/collections/' + h; return; }
    loadingSheet(o.label);
    loadIndex().then(function () {
      var items = objItems(o);
      if (!items.length) { location.href = o.url; return; }
      var min = Math.min.apply(null, items.map(function (p) { return p.p; }));
      var noff = items.filter(function (p) { return p.d > 0; }).length;
      var maxoff = Math.max.apply(null, items.map(function (p) { return p.d; }));
      var fc = {}; items.forEach(function (p) { if (FMT[p.f]) fc[p.f] = (fc[p.f] || 0) + 1; });
      var fchips = Object.keys(fc);
      var ic = {}; items.forEach(function (p) { (p.i || []).forEach(function (i) { ic[i] = (ic[i] || 0) + 1; }); });
      var ings = Object.keys(ic).filter(function (k) { return ic[k] >= 2; }).sort(function (a, b) { return ic[b] - ic[a]; }).slice(0, 8);
      var list = starters(items, fmt);
      openSheet(o.label,
        '<div class="hn-obj-hero">' + (o.img ? '<img src="' + esc(o.img) + '" alt="">' : '') + '<div><h3>' + esc(o.label) + '</h3></div></div>' +
        '<div class="hn-obj-stats hn-num"><span><b>' + items.length + '</b> produtos</span><span>a partir de <b>R$ ' + brl(min) + '</b></span>' +
          (noff ? '<span><b>' + noff + '</b> em oferta, até ' + pct(maxoff) + '%</span>' : '') + '</div>' +
        '<div class="hn-pad">' +
          (fchips.length > 1 ? '<p class="hn-sb-title">Formato</p><div class="hn-sp-chips" style="margin-bottom:22px"><button class="hn-chip" type="button" aria-pressed="' + !fmt + '" data-hn-obj="' + h + '">Todos</button>' +
            fchips.map(function (f) { return '<button class="hn-chip" type="button" aria-pressed="' + (fmt === f) + '" data-hn-obj="' + h + '" data-hn-fmt="' + esc(f) + '">' + esc(f) + ' <small class="hn-num">' + fc[f] + '</small></button>'; }).join('') + '</div>' : '') +
          '<p class="hn-sb-title">' + (fmt ? esc(fmt) + ': do preço de entrada ao mais completo' : 'Para começar: os mais procurados') + '</p>' +
          '<div class="hn-mini-list">' + list.map(mrow).join('') + '</div>' +
          (ings.length ? '<p class="hn-sb-title" style="margin-top:24px">Por ingrediente</p><div class="hn-sp-chips">' + ings.map(function (i) { return '<a class="hn-chip" href="/search?q=' + encodeURIComponent(i) + '">' + esc(i) + ' <small class="hn-num">' + ic[i] + '</small></a>'; }).join('') + '</div>' : '') +
          (CUIDADO[h] ? '<div class="hn-warn">' + ICO.info + '<span>' + esc(CUIDADO[h]) + '</span></div>' : '') +
        '</div>',
        '<a class="hn-btn" href="' + esc(o.url) + '">Ver os ' + items.length + ' produtos</a><a class="hn-btn hn-line" href="' + wa('Olá! Quero ajuda com ' + o.label.toLowerCase() + '.') + '" target="_blank" rel="noopener">Perguntar</a>');
    }).catch(function () { location.href = o.url; });
  }

  /* ---------- guia de 3 perguntas ---------- */
  var quiz = { step: 0, obj: null, exp: null, fmt: null };
  var EXP = [['primeira', 'É a primeira vez', 'Quero começar pelo básico'], ['alguns', 'Já uso alguns', 'Quero acertar o próximo'], ['experiente', 'Uso há bastante tempo', 'Quero opções mais completas']];
  var QF = [['Pó', 'Pó para misturar', 'Na água, no leite ou no shake'], ['Cápsula', 'Cápsula', 'Prático, sem preparo'], ['Gotas ou líquido', 'Gotas ou líquido', 'Fácil de tomar'], ['Sachê', 'Sachê', 'Dose pronta para levar'], ['', 'Tanto faz', 'Mostre o que fizer mais sentido']];
  function quizHTML() {
    var prog = '<div class="hn-quiz-prog" aria-hidden="true">' + [0, 1, 2].map(function (i) { return '<i class="' + (i <= quiz.step ? 'hn-on' : '') + '"></i>'; }).join('') + '</div>';
    var objs = Object.keys(OBJ).map(function (k) { return OBJ[k]; });
    if (quiz.step === 0) return prog + '<div class="hn-pad hn-q"><h3>O que você quer melhorar?</h3><p>Escolha o que mais pesa agora.</p><div class="hn-opts hn-two">' +
      objs.map(function (o) { return '<button class="hn-opt" type="button" data-hn-q="obj" data-v="' + o.h + '" aria-pressed="' + (quiz.obj === o.h) + '">' + (o.img ? '<img src="' + esc(o.img) + '" alt="">' : '') + esc(o.label) + '</button>'; }).join('') + '</div></div>';
    if (quiz.step === 1) return prog + '<div class="hn-pad hn-q"><h3>Você já usa suplemento?</h3><p>Assim a gente ajusta por onde começar.</p><div class="hn-opts">' +
      EXP.map(function (e) { return '<button class="hn-opt" type="button" data-hn-q="exp" data-v="' + e[0] + '" aria-pressed="' + (quiz.exp === e[0]) + '"><span>' + e[1] + '<small>' + e[2] + '</small></span></button>'; }).join('') + '</div></div>';
    var o = OBJ[quiz.obj], items = objItems(o);
    if (quiz.step === 2) {
      var fc = {}; items.forEach(function (p) { fc[p.f] = (fc[p.f] || 0) + 1; });
      return prog + '<div class="hn-pad hn-q"><h3>Qual formato você prefere?</h3><p>Em ' + esc(o.label.toLowerCase()) + ', a loja tem:</p><div class="hn-opts">' +
        QF.filter(function (f) { return !f[0] || fc[f[0]]; }).map(function (f) {
          return '<button class="hn-opt" type="button" data-hn-q="fmt" data-v="' + esc(f[0]) + '" aria-pressed="' + (quiz.fmt === f[0]) + '"><span>' + f[1] + '<small>' + (f[0] ? fc[f[0]] + ' produto' + (fc[f[0]] > 1 ? 's' : '') + ' · ' : '') + f[2] + '</small></span></button>';
        }).join('') + '</div></div>';
    }
    var pool = starters(items, quiz.fmt || null);
    if (!pool.length) pool = starters(items, null);
    if (quiz.exp === 'experiente') pool = pool.slice().reverse();
    var note = quiz.exp === 'primeira' ? 'Na primeira vez, comece por um produto só, no uso indicado no rótulo. Se tiver dúvida de dose ou combinação, a equipe responde no WhatsApp.'
      : quiz.exp === 'experiente' ? 'Mostramos primeiro as opções mais completas. Quer comparar com o que você já usa? Mande a foto do rótulo no WhatsApp.'
      : 'Estas são boas próximas escolhas. Para combinar com o que você já usa, a equipe ajuda no WhatsApp.';
    return '<div class="hn-pad hn-q"><span class="hn-eyebrow">Seu ponto de partida</span><h3 style="margin-top:8px">' + esc(o.label) + (quiz.fmt ? ', em ' + esc(quiz.fmt.toLowerCase()) : '') + '</h3>' +
      '<div class="hn-result-note">' + note + '</div><div class="hn-mini-list">' + pool.slice(0, 3).map(mrow).join('') + '</div>' +
      (CUIDADO[o.h] ? '<div class="hn-warn">' + ICO.info + '<span>' + esc(CUIDADO[o.h]) + '</span></div>' : '') +
      '<p style="margin:20px 0 0;display:flex;gap:18px;flex-wrap:wrap"><a class="hn-link" href="' + esc(o.url) + '">Ver tudo de ' + esc(o.label.toLowerCase()) + ' (' + items.length + ')</a><button class="hn-link" type="button" data-hn-quiz>Refazer</button></p></div>';
  }
  function renderQuiz() {
    var done = quiz.step > 2;
    openSheet(done ? 'Por onde começar' : 'Pergunta ' + (quiz.step + 1) + ' de 3', quizHTML(),
      done ? '<a class="hn-btn" href="' + wa('Olá! Respondi o guia: ' + OBJ[quiz.obj].label + (quiz.fmt ? ', ' + quiz.fmt : '') + '. Pode me ajudar a escolher?') + '" target="_blank" rel="noopener">Falar com a equipe</a>'
        : (quiz.step ? '<button class="hn-btn hn-line" type="button" data-hn-qback>' + ICO.back + ' Voltar</button>' : ''));
  }
  function startQuiz() {
    quiz = { step: 0, obj: null, exp: null, fmt: null };
    loadingSheet('Pergunta 1 de 3');
    loadIndex().then(renderQuiz);
  }

  /* ---------- busca ---------- */
  var SYN = {
    whey: ['whey', 'proteina', 'protein'], way: ['whey'], wey: ['whey'], whei: ['whey'], proteina: ['proteina', 'whey', 'protein'], protein: ['proteina', 'whey'],
    creatina: ['creatina', 'creapure', 'creatine', 'monohidratada'], creapure: ['creatina', 'creapure'], creatine: ['creatina'],
    colageno: ['colageno', 'collagen', 'verisol'], collagen: ['colageno', 'collagen'], verisol: ['colageno'],
    omega: ['omega', 'epa', 'dha', 'omega 3'], peixe: ['omega'], epa: ['omega'], dha: ['omega'],
    magnesio: ['magnesio', 'magnesium'], magnesium: ['magnesio'],
    pretreino: ['pretreino', 'pre treino', 'pre workout'], preworkout: ['pre treino'],
    melatonina: ['melatonina', 'melatonin'], melatonin: ['melatonina'],
    sono: ['sono', 'dormir', 'relaxamento', 'melatonina'], dormir: ['dormir', 'sono', 'relaxamento', 'melatonina'], insonia: ['sono', 'dormir', 'melatonina'],
    d3: ['d3', 'vitamina d', 'vit d'], colecalciferol: ['d3'],
    cafeina: ['cafeina', 'caffeine', 'cafe', 'coffee'], cafe: ['cafe', 'coffee', 'supercoffee'], coffee: ['cafe', 'supercoffee'],
    bcaa: ['bcaa', 'aminoacidos'], aminoacido: ['aminoacidos', 'bcaa', 'glutamina'], glutamine: ['glutamina'],
    multivitaminico: ['multivitaminico', 'multi'], multi: ['multivitaminico', 'multi'],
    barra: ['barra', 'bar', 'wafer'], snack: ['barra', 'snack', 'crisp', 'granola'], garrafa: ['garrafa', 'termica', 'pacco'],
    vegano: ['vegano', 'vegana', 'veggie'], vegana: ['vegana', 'vegano', 'veggie'],
    intestino: ['intestino', 'fibras', 'probioticos', 'digestiva'], probiotico: ['probioticos', 'probio'],
    emagrecer: ['metabolica', 'termogenico', 'fibras'], termogenico: ['termogenico', 'metabolica'], metabolismo: ['metabolica', 'termogenico'],
    energia: ['energia', 'disposicao', 'cafeina'], foco: ['foco', 'nootropicos'],
    cabelo: ['cabelo', 'pele', 'colageno'], pele: ['pele', 'colageno'], unhas: ['unhas', 'pele', 'colageno'],
    olhos: ['luteina', 'zeaxantina', 'vision'], visao: ['luteina', 'zeaxantina', 'vision'],
    crianca: ['infantil', 'kids', 'criancas'], kids: ['infantil', 'kids'], infantil: ['infantil', 'kids'],
    mulher: ['mulher', 'feminina', 'femme'], glp1: ['glp'], ozempic: ['glp'], mounjaro: ['glp']
  };
  var STOP = { de: 1, da: 1, do: 1, para: 1, pra: 1, com: 1, e: 1, o: 1, a: 1, os: 1, as: 1, em: 1, um: 1, uma: 1 };
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = []; for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      var cur = [i], best = i;
      for (j = 1; j <= b.length; j++) { cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); best = Math.min(best, cur[j]); }
      if (best > max) return max + 1; prev = cur;
    }
    return prev[b.length];
  }
  function tokMatch(q, list) {
    var best = 0;
    for (var k = 0; k < list.length; k++) {
      var w = list[k];
      if (w === q) return 1;
      if (q.length >= 3 && w.indexOf(q) === 0) best = Math.max(best, 0.85);
      else if (q.length >= 5 && best < 0.6 && w[0] === q[0]) {
        var m = q.length >= 8 ? 2 : 1;
        if (lev(q, w, m) <= m || (q.length >= 6 && w.length > q.length && lev(q, w.slice(0, q.length), m) <= m)) best = 0.6;
      }
    }
    return best;
  }
  function altMatch(a, list, full) {
    if (a.indexOf(' ') > -1) return new RegExp('(^|[^a-z0-9])' + a.replace(/ /g, '[\\s-]') + '([^a-z0-9]|$)').test(full) ? 1 : 0;
    return tokMatch(a, list);
  }
  function prepQuery(raw) {
    var q = fold(raw).replace(/pre[\s-]?treino/g, 'pretreino').replace(/omega[\s-]?3/g, 'omega').replace(/vitamina\s+d3?\b/g, 'd3').replace(/glp[\s-]?1/g, 'glp1').replace(/oleo de peixe/g, 'peixe');
    return toks(q).filter(function (w) { return !STOP[w]; });
  }
  function search(raw) {
    var qs = prepQuery(raw); if (!qs.length) return { items: [], qs: qs };
    var groups = qs.map(function (q) { return [q].concat(SYN[q] || []); });
    var scored = [];
    IDX.forEach(function (d) {
      var total = 0;
      for (var g = 0; g < groups.length; g++) {
        var alts = groups[g], sc = 0;
        alts.forEach(function (a, i) { var w = i ? 0.95 : 1; sc = Math.max(sc, w * Math.max(altMatch(a, d.tt, d.ft) * 3, altMatch(a, d.bt, d.fb) * 2.2, altMatch(a, d.xt, d.fx) * 1.2)); });
        if (sc && alts.some(function (a) { return new RegExp('(^|\\s)sem ' + a).test(d.ft); })) sc = 0.2;
        if (!sc) return;
        total += sc;
      }
      scored.push([total + (1 - d.rank / IDX.length) * 0.8, d]);
    });
    scored.sort(function (a, b) { return b[0] - a[0]; });
    return { items: scored.map(function (s) { return s[1]; }), qs: qs };
  }
  var LINKS = [];
  function buildLinks() {
    var seen = {};
    var add = function (kind, label, url, extra) {
      label = (label || '').replace(/\s+\d+$/, '').trim(); if (!label || seen[label]) return; seen[label] = 1;
      LINKS.push({ kind: kind, label: label, url: url, h: extra, w: toks(fold(label)), f: fold(label) });
    };
    Object.keys(OBJ).forEach(function (k) { add('obj', OBJ[k].label, OBJ[k].url, k); });
    $$('.hn-mega-links a').forEach(function (a) { add('col', a.firstChild ? a.firstChild.textContent : a.textContent, a.getAttribute('href')); });
    $$('.hn-az a').forEach(function (a) { add('brand', a.textContent, a.getAttribute('href')); });
  }
  function linkMatches(raw) {
    var qs = prepQuery(raw); if (!qs.length) return [];
    return LINKS.filter(function (l) { return qs.every(function (q) { return [q].concat(SYN[q] || []).some(function (a) { return altMatch(a, l.w, l.f) >= 0.6; }); }); }).slice(0, 6);
  }
  var SUGG = ['Whey', 'Creatina', 'Magnésio', 'Colágeno', 'Ômega 3', 'Pré-treino', 'Vitamina D', 'Melatonina'];
  var sp = $('#hn-sp'), qi = $('#hn-q'), kb = -1;
  function hl(text, qs) {
    var out = esc(text);
    qs.forEach(function (q) { if (q.length >= 2) out = out.replace(new RegExp('(^|[\\s(])(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[^\\s,]*)', 'i'), '$1<mark>$2</mark>'); });
    return out;
  }
  function resRow(p, qs) {
    return '<li><a href="' + esc(p.u) + '">' + '<span class="hn-sp-pic">' + pic(p, 56) + '</span><span><b>' + hl(p.t, qs) + '</b><small>' + esc(p.b) + (p.n > 1 ? ' · ' + p.n + ' opções' : '') + '</small></span>' + priceHTML(p) + '</a></li>';
  }
  function getVis() { try { return JSON.parse(localStorage.getItem(FREE_KEY) || '[]'); } catch (e) { return []; } }
  function renderSearch() {
    if (!sp) return;
    var raw = qi.value.trim(); kb = -1;
    $('[data-hn-clear]').hidden = !raw;
    var objs = Object.keys(OBJ).map(function (k) { return OBJ[k]; });
    if (!raw) {
      var v = IDX ? getVis().map(byHandle).filter(Boolean).slice(0, 4) : [];
      sp.innerHTML = '<div class="hn-sp-block"><h4>Sugestões</h4><div class="hn-sp-chips">' + SUGG.map(function (s) { return '<button class="hn-chip" type="button" data-hn-term="' + s + '">' + s + '</button>'; }).join('') + '</div></div>' +
        (objs.length ? '<div class="hn-sp-block"><h4>Pelo que você quer melhorar</h4><div class="hn-sp-chips">' + objs.map(function (o) { return '<a class="hn-chip" href="' + esc(o.url) + '" data-hn-obj="' + o.h + '">' + esc(o.label) + '</a>'; }).join('') + '</div></div>' : '') +
        (v.length ? '<div class="hn-sp-block"><h4>Vistos por você</h4><ul class="hn-sp-res">' + v.map(function (p) { return resRow(p, []); }).join('') + '</ul></div>' : '') +
        '<div class="hn-sp-block"><a class="hn-sp-help" href="' + wa('Olá! Estou procurando um produto e não achei.') + '" target="_blank" rel="noopener">Não achou? <b>Pergunte para a equipe no WhatsApp</b></a></div>';
      return;
    }
    if (!IDX) { sp.innerHTML = '<p class="hn-sp-note">Buscando…</p>'; loadIndex().then(renderSearch); return; }
    var r = search(raw), items = r.items, qs = r.qs, links = linkMatches(raw), dropped = [];
    if (!items.length && qs.length > 1) {
      var keep = qs.filter(function (q) { return search(q).items.length; });
      dropped = qs.filter(function (q) { return keep.indexOf(q) < 0; });
      if (keep.length) { items = search(keep.join(' ')).items; qs = keep; links = linkMatches(keep.join(' ')); }
    }
    if (!items.length && !links.length) {
      var near = SUGG.map(function (s) { return [s, lev(fold(raw), fold(s), 12)]; }).sort(function (a, b) { return a[1] - b[1]; }).slice(0, 3).map(function (x) { return x[0]; });
      sp.innerHTML = '<div class="hn-sp-empty"><p>Não encontramos <b>"' + esc(raw) + '"</b> entre os produtos à venda.</p><div class="hn-sp-block"><h4>Talvez você procure</h4><div class="hn-sp-chips">' +
        near.map(function (s) { return '<button class="hn-chip" type="button" data-hn-term="' + s + '">' + s + '</button>'; }).join('') + '</div></div>' +
        '<div class="hn-sp-block"><a class="hn-sp-help" href="' + wa('Olá! Vocês têm ' + raw + '?') + '" target="_blank" rel="noopener">A equipe confere para você. <b>Perguntar no WhatsApp</b></a></div></div>';
      return;
    }
    sp.innerHTML = (dropped.length && items.length ? '<p class="hn-sp-note">Nada com <b>"' + esc(dropped.join(' ')) + '"</b>. Mostrando <b>"' + esc(qs.join(' ')) + '"</b>.</p>' : '') +
      (links.length ? '<div class="hn-sp-block"><h4>Atalhos</h4><div class="hn-sp-chips">' + links.map(function (l) {
        return '<a class="hn-chip" href="' + esc(l.url) + '"' + (l.kind === 'obj' ? ' data-hn-obj="' + l.h + '"' : '') + '>' + (l.kind === 'brand' ? 'Marca ' : '') + esc(l.label) + '</a>';
      }).join('') + '</div></div>' : '') +
      (items.length ? '<div class="hn-sp-block"><h4 class="hn-num">' + items.length + ' produto' + (items.length > 1 ? 's' : '') + '</h4><ul class="hn-sp-res">' + items.slice(0, 6).map(function (p) { return resRow(p, qs); }).join('') + '</ul>' +
        (items.length > 6 ? '<a class="hn-btn hn-line hn-sp-all hn-num" href="/search?q=' + encodeURIComponent(raw) + '">Ver os ' + items.length + ' resultados</a>' : '') + '</div>' : '');
  }
  function openSearch() {
    if (!sp) return;
    if (mq.matches) document.body.classList.add('hn-searching', 'hn-lock');
    closeMega(); sp.hidden = false; qi.setAttribute('aria-expanded', 'true'); renderSearch(); loadIndex();
  }
  function closeSearch() {
    if (!sp || sp.hidden) return;
    sp.hidden = true; qi.setAttribute('aria-expanded', 'false');
    if (document.body.classList.contains('hn-searching')) {
      document.body.classList.remove('hn-searching');
      if ((!sheet || sheet.hidden) && (!drawer || drawer.hidden)) document.body.classList.remove('hn-lock');
    }
  }
  if (qi) {
    var setPh = function () { qi.placeholder = mq.matches ? 'Buscar produto, marca ou objetivo' : 'Busque por produto, marca, ingrediente ou objetivo'; };
    setPh(); if (mq.addEventListener) mq.addEventListener('change', setPh);
    qi.addEventListener('focus', openSearch);
    qi.addEventListener('input', function () { if (sp.hidden) openSearch(); else renderSearch(); });
    qi.addEventListener('keydown', function (e) {
      var rows = $$('.hn-sp-res a', sp);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (!rows.length) return;
        kb = (kb + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
        rows.forEach(function (r, i) { r.classList.toggle('hn-kb', i === kb); }); rows[kb].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && kb >= 0 && rows[kb]) { e.preventDefault(); location.href = rows[kb].href; }
    });
    $('[data-hn-clear]').addEventListener('click', function () { qi.value = ''; qi.focus(); renderSearch(); });
    $('[data-hn-search-back]').addEventListener('click', function () { closeSearch(); qi.blur(); });
    document.addEventListener('pointerdown', function (e) {
      if (!sp.hidden && e.target.closest && !e.target.closest('[data-hn-search]') && !document.body.classList.contains('hn-searching')) closeSearch();
    });
  }

  /* ---------- mega-menu e gaveta ---------- */
  var megaOpen = null, megaT;
  function openMega(k) {
    if (mq.matches) return openDrawer(k);
    closeSearch(); if (qi && document.activeElement === qi) qi.blur();
    $$('[data-hn-mega]').forEach(function (m) { m.hidden = m.dataset.hnMega !== String(k); });
    $$('.hn-nav > button').forEach(function (b) { b.setAttribute('aria-expanded', b.dataset.hnG === String(k)); });
    megaOpen = String(k);
  }
  function closeMega() {
    if (megaOpen === null) return;
    megaOpen = null;
    $$('[data-hn-mega]').forEach(function (m) { m.hidden = true; });
    $$('.hn-nav > button').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function openDrawer(k) {
    if (!drawer) return;
    closeMega(); closeSearch();
    if (sheet && !sheet.hidden) { sheet.classList.remove('hn-open'); sheet.hidden = true; }
    $$('details', drawer).forEach(function (d) { d.open = k && d.dataset.k === String(k); });
    showLayer(drawer);
  }
  var nav = $('.hn-nav');
  if (nav) {
    nav.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; megaOpen === b.dataset.hnG ? closeMega() : openMega(b.dataset.hnG); });
    nav.addEventListener('mouseover', function (e) {
      var b = e.target.closest('button'); if (!b || mq.matches || window.matchMedia('(hover:none)').matches) return;
      clearTimeout(megaT); megaT = setTimeout(function () { openMega(b.dataset.hnG); }, megaOpen ? 0 : 140);
    });
    hdr.addEventListener('mouseleave', function () { clearTimeout(megaT); if (megaOpen) megaT = setTimeout(closeMega, 260); });
    $$('[data-hn-mega]').forEach(function (m) { m.addEventListener('mouseenter', function () { clearTimeout(megaT); }); });
  }

  /* ---------- carrossel ---------- */
  $$('[data-hn-car]').forEach(function (car) {
    var track = $('.hn-slides', car), slides = $$('.hn-slide', car), tabs = $$('.hn-car-tab', car);
    if (slides.length < 2) return;
    var cur = 0, timer = null, hover = false, paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function mark(i) { tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i); if (k === i) { var b = $('i', t); b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } }); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      if (mq.matches) { cur = i; track.scrollTo({ left: slides[i].offsetLeft - 16, behavior: 'smooth' }); mark(i); arm(); return; }
      slides[cur].classList.remove('hn-on'); slides[cur].setAttribute('aria-hidden', 'true'); slides[cur].tabIndex = -1;
      cur = i; slides[cur].classList.add('hn-on'); slides[cur].removeAttribute('aria-hidden'); slides[cur].removeAttribute('tabindex');
      mark(cur); arm();
    }
    function arm() { clearTimeout(timer); car.classList.toggle('hn-paused', paused || hover); if (!paused && !hover) timer = setTimeout(function () { go(cur + 1); }, 6000); }
    tabs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.i); }); });
    var pb = $('[data-hn-pause]', car);
    if (pb) pb.addEventListener('click', function () { paused = !paused; pb.setAttribute('aria-pressed', paused); pb.setAttribute('aria-label', paused ? 'Continuar carrossel' : 'Pausar carrossel'); arm(); });
    car.addEventListener('mouseenter', function () { hover = true; arm(); }); car.addEventListener('mouseleave', function () { hover = false; arm(); });
    car.addEventListener('focusin', function () { hover = true; arm(); }); car.addEventListener('focusout', function () { hover = false; arm(); });
    var scT; track.addEventListener('scroll', function () {
      if (!mq.matches) return; clearTimeout(scT);
      scT = setTimeout(function () { var i = Math.round(track.scrollLeft / (slides[0].offsetWidth + 10)); if (i !== cur) { cur = i; mark(i); } arm(); }, 90);
    }, { passive: true });
    arm();
  });

  /* ---------- abas da vitrine e filtros das ofertas ---------- */
  $$('[data-hn-tabs]').forEach(function (g) {
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[role=tab]'); if (!t) return;
      $$('[role=tab]', g).forEach(function (x) { x.setAttribute('aria-selected', x === t); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = x !== t; });
    });
  });
  $$('[data-hn-sort-group]').forEach(function (g) {
    var sec = g.closest('section'), rail = $('[data-hn-sortable]', sec); if (!rail) return;
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hn-sort]'); if (!b) return;
      $$('[data-hn-sort]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      var cards = $$('.hn-card', rail), mode = b.dataset.hnSort;
      cards.sort(function (a, c) { return mode === 'pct' ? (+c.dataset.d) - (+a.dataset.d) : (+a.dataset.p) - (+c.dataset.p); });
      cards.forEach(function (c) { c.hidden = mode === 'u100' && +c.dataset.p > 10000; rail.appendChild(c); });
      rail.scrollTo({ left: 0 });
    });
  });

  /* ---------- vistos por você ---------- */
  if (window.hnProduto) { try { var v = getVis().filter(function (h) { return h !== window.hnProduto; }); v.unshift(window.hnProduto); localStorage.setItem(FREE_KEY, JSON.stringify(v.slice(0, 12))); } catch (e) {} }
  var vis = $('[data-hn-vistos]');
  function renderVis() {
    if (!vis) return;
    var hs = getVis(); if (!hs.length) { vis.hidden = true; return; }
    loadIndex().then(function () {
      var items = hs.map(byHandle).filter(Boolean);
      vis.hidden = !items.length;
      $('[data-hn-vis-rail]', vis).innerHTML = items.map(card).join('');
    }).catch(function () {});
  }
  if (vis) {
    $('[data-hn-vis-clear]', vis).addEventListener('click', function () { try { localStorage.removeItem(FREE_KEY); } catch (e) {} vis.hidden = true; });
    if ('requestIdleCallback' in window) requestIdleCallback(renderVis); else setTimeout(renderVis, 800);
  }

  /* ---------- horário de Cuiabá (UTC-4): seg–sex 8h–18h, sáb 8h–12h ---------- */
  (function () {
    var now = new Date(Date.now() - 4 * 3600e3), d = now.getUTCDay(), m = now.getUTCHours() * 60 + now.getUTCMinutes();
    var H = { 1: [480, 1080], 2: [480, 1080], 3: [480, 1080], 4: [480, 1080], 5: [480, 1080], 6: [480, 720] };
    var fmt = function (x) { return Math.floor(x / 60) + 'h' + (x % 60 ? String(x % 60).padStart(2, '0') : ''); };
    var dias = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'], st;
    if (H[d] && m >= H[d][0] && m < H[d][1]) st = { open: true, text: 'Atendendo agora, até ' + fmt(H[d][1]), short: 'Atendendo agora' };
    else for (var k = 0; k < 8 && !st; k++) { var dd = (d + k) % 7; if (H[dd] && (k > 0 || m < H[dd][0])) { var w = k === 0 ? 'hoje' : k === 1 ? 'amanhã' : dias[dd]; st = { open: false, text: 'Volta ' + w + ' às ' + fmt(H[dd][0]) + '. Pode mandar mensagem.', short: 'Volta ' + w + ' às ' + fmt(H[dd][0]) }; } }
    $$('[data-hn-dot]').forEach(function (x) { x.classList.toggle('hn-open', st.open); });
    $$('[data-hn-status]').forEach(function (x) { x.textContent = st.short; });
    $$('[data-hn-live]').forEach(function (x) { x.innerHTML = '<b>WhatsApp</b> · ' + st.text; });
  })();

  /* ---------- um só ouvinte para cliques ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var ob = t.closest('[data-hn-obj]');
    if (ob && !e.metaKey && !e.ctrlKey) { e.preventDefault(); closeSearch(); closeMega(); openObjective(ob.dataset.hnObj, ob.dataset.hnFmt || null); return; }
    if (t.closest('[data-hn-quiz]')) { e.preventDefault(); closeMega(); closeSearch(); startQuiz(); return; }
    var qa = t.closest('[data-hn-q]'); if (qa) { quiz[qa.dataset.hnQ] = qa.dataset.v || null; quiz.step++; renderQuiz(); return; }
    if (t.closest('[data-hn-qback]')) { quiz.step = Math.max(0, quiz.step - 1); renderQuiz(); return; }
    var term = t.closest('[data-hn-term]'); if (term) { qi.value = term.dataset.hnTerm; qi.focus(); renderSearch(); return; }
    var om = t.closest('[data-hn-menu]');
    if (om) { e.preventDefault(); var k = om.dataset.hnMenu; if (k === 'marcas') { var g = $$('.hn-nav > button').find(function (b) { return /marca/i.test(b.textContent); }); k = g ? g.dataset.hnG : ''; } if (k && !mq.matches) { openMega(k); window.scrollTo({ top: 0, behavior: 'smooth' }); } else openDrawer(k); return; }
    if (t.closest('[data-hn-close]') || t.closest('[data-hn-scrim]')) { closeLayers(); return; }
    if (t.closest('[data-hn-tb-search]')) { if (qi) qi.focus(); return; }
    var ar = t.closest('[data-hn-rail] button'); if (ar) { var r = document.getElementById(ar.parentElement.dataset.hnRail); if (r) r.scrollBy({ left: ar.dataset.dir * r.clientWidth * 0.8, behavior: 'smooth' }); return; }
    /* adicionar dentro do painel: fecha o painel e deixa o carrinho lateral do tema abrir */
    if (t.closest('[data-cart-add-button]') && t.closest('#hn-sheet')) { setTimeout(closeLayers, 50); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if ((sheet && !sheet.hidden) || (drawer && !drawer.hidden)) closeLayers(); else if (megaOpen) closeMega(); else if (sp && !sp.hidden) { closeSearch(); qi.blur(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var layer = sheet && !sheet.hidden ? sheet : drawer && !drawer.hidden ? drawer : null; if (!layer) return;
    var f = $$('a[href],button:not([disabled]),summary,input', layer).filter(function (x) { return x.offsetParent; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* no celular, a linha de grupos some ao rolar para baixo e volta ao subir */
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (hdr) hdr.classList.toggle('hn-compact', y > 140 && y > lastY);
    lastY = y; if (megaOpen && y > 240) closeMega();
  }, { passive: true });

  buildLinks();
})();
